import { render } from "./FormRole.vue?vue&type=template&id=4fb190dd&scoped=true"
import script from "./FormRole.vue?vue&type=script&lang=js"
export * from "./FormRole.vue?vue&type=script&lang=js"

import "./FormRole.vue?vue&type=style&index=0&id=4fb190dd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb190dd"]])

export default __exports__